<template>
  <div class="overflow-hidden rounded-2xl border border-[#1c4848]/10 bg-white">
    <img v-if="attrs.src" :src="attrs.src" :alt="attrs.alt || ''" class="max-h-[460px] w-full object-contain bg-[#1c4848]/[0.03]" draggable="false">
    <ImagePicker v-if="!readOnly" :context="context" :has-image="Boolean(attrs.src)" @picked="set({ src: $event })" />
    <div class="px-2 pb-2">
      <BlockField :model-value="attrs.caption" placeholder="Caption" :read-only="readOnly" input-class="text-center text-xs text-[#1c4848]/65" @update:model-value="set({ caption: $event })" />
    </div>
  </div>
</template>

<script setup>
import BlockField from '@/components/writer/views/BlockField.vue';
import ImagePicker from '@/components/writer/views/ImagePicker.vue';

defineProps({ attrs: Object, readOnly: Boolean, context: Object, set: Function, kind: String });
</script>
